export const message = {
  officialAnswer: "Respuesta oficial",
  answerCheckedMessage: "Respuesta marcada con éxito",
  setOfficialAnswerContent:
    "¿Está seguro de marcar esta como la respuesta oficial?",
};
